import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Alert, ErpSelect, Field, Modal } from "../../components/erp";
import { errorText } from "../../api/client";
import { supplierApi } from "./api";

const TYPES = [{ value: "Individual", label: "Individual" }, { value: "Bussiness", label: "Bussiness" }]; // legacy option values kept

const empty = { SupplierID: "", SupplierType: "", SupplierName: "", GSTNumber: "", PANNumber: "", SupplierBank: "", BankAccNo: "", IFSCCode: "", Address: "", EMailID: "", PhoneNumber: "", PurchaseCenter: "" };
export type SupplierForm = typeof empty;

/** Port of v3/Purchase/modalSupplier.php + Ajax/AjaxSupplier.php */
export const SupplierModal: React.FC<{ open: boolean; onClose: () => void; onSaved?: (row: Record<string, unknown>) => void; initial?: Partial<SupplierForm> }> =
  ({ open, onClose, onSaved, initial }) => {
    const qc = useQueryClient();
    const [f, setF] = useState<SupplierForm>({ ...empty, ...initial });
    const [msg, setMsg] = useState<{ kind: "success" | "danger"; text: string } | null>(null);
    const [busy, setBusy] = useState(false);
    const set = (k: keyof SupplierForm) => (e: React.ChangeEvent<HTMLInputElement>) => setF({ ...f, [k]: e.target.value });

    const save = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!f.SupplierType || !f.SupplierName || !f.GSTNumber || !f.PANNumber) { setMsg({ kind: "danger", text: "Please fill all required fields" }); return; }
      setBusy(true); setMsg(null);
      try {
        const r = await supplierApi.post(f);
        if (r.Error) { setMsg({ kind: "danger", text: r.Error }); return; }
        setMsg({ kind: "success", text: r.Msg || "Success" });
        qc.invalidateQueries({ queryKey: ["purchase", "dropdowns"] });
        qc.invalidateQueries({ queryKey: ["purchase", "suppliers"] });
        onSaved?.(r.Data || {});
        setF({ ...empty });
      } catch (err) { setMsg({ kind: "danger", text: errorText(err) }); } finally { setBusy(false); }
    };

    return (
      <Modal open={open} onClose={onClose} title={f.SupplierID ? "Edit Supplier" : "Create Supplier"} testId="supplier-modal">
        <form onSubmit={save} data-testid="supplier-form">
          <div className="row">
            <Field label="Suppliers Type " required htmlFor="drpSupplierType" col="col-sm-4 mb-3">
              <ErpSelect id="drpSupplierType" value={f.SupplierType} options={TYPES} onChange={(v) => setF({ ...f, SupplierType: v })} />
            </Field>
            <Field label="Suppliers Name" required col="col-sm-4 mb-3"><input className="form-control" id="txtSupplierName" placeholder="Enter Financier Name " value={f.SupplierName} onChange={set("SupplierName")} data-testid="txtSupplierName" /></Field>
            <Field label="GST Number " required col="col-sm-4 mb-3"><input className="form-control" id="txtGSTNumber" value={f.GSTNumber} onChange={set("GSTNumber")} data-testid="txtGSTNumber" /></Field>
            <Field label="PAN Number " required col="col-sm-4 mb-3"><input className="form-control" id="txtPANNumber" value={f.PANNumber} onChange={set("PANNumber")} data-testid="txtPANNumber" /></Field>
            <Field label="Suppliers Bank Name" col="col-sm-4 mb-3"><input className="form-control" id="txtSupplierBankName" value={f.SupplierBank} onChange={set("SupplierBank")} data-testid="txtSupplierBankName" /></Field>
            <Field label="Bank Account Number " col="col-sm-4 mb-3"><input className="form-control" id="txtBankAccountNumber" value={f.BankAccNo} onChange={set("BankAccNo")} data-testid="txtBankAccountNumber" /></Field>
            <Field label="IFSCCode " col="col-sm-4 mb-3"><input className="form-control" id="txtIFSCCode" value={f.IFSCCode} onChange={set("IFSCCode")} data-testid="txtIFSCCode" /></Field>
            <Field label="Supplier Address " col="col-sm-4 mb-3"><input className="form-control" id="txtSupplierAddress" value={f.Address} onChange={set("Address")} data-testid="txtSupplierAddress" /></Field>
            <Field label="Supplier EMail ID" col="col-sm-4 mb-3"><input className="form-control" id="txtSupplierEMailID" value={f.EMailID} onChange={set("EMailID")} data-testid="txtSupplierEMailID" /></Field>
            <Field label="Phone Number " col="col-sm-4 mb-3"><input className="form-control" id="txtPhoneNumber" value={f.PhoneNumber} onChange={set("PhoneNumber")} data-testid="txtPhoneNumber" /></Field>
          </div>
          {msg && <Alert kind={msg.kind} testId="supplier-msg">{msg.text}</Alert>}
          <div className="text-center">
            <button type="button" className="btn btn-danger me-2" onClick={onClose} data-testid="supplier-close">Close</button>
            <button type="submit" className="btn btn-primary" disabled={busy} data-testid="supplier-save">Save</button>
          </div>
        </form>
      </Modal>
    );
  };
